import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { makeStyles } from '@mui/styles'
import { EnvironmentProvider } from '../../../custom-components/context/EnvironmentContext'
import { IconThemeProvider } from '../../../custom-components/context/IconThemesContext'
import DoformsMessage from '../../../custom-components/DoformsMessage'
import { ENV_ACTIONS } from '../../../reducers/environmentReducer'
import { LOOKUPS_ACTIONS } from '../../../reducers/lookupsReducer'
import '../../../styles.css'
import DashboardSplitPane from '../../core/Dashboard/DashboardSplitPane'
import { getAllProjects, getProjectForms } from '../../data/dataServices'
import LookupsDashboard from './LookupsDashboard'
import LookupsData from './LookupsData'
import { useParams } from 'react-router-dom'
import { useUrlQueryParams } from 'utils/hooks/useUrlQueryParams'
import useProject from '../dis/hooks/useProject'

const useStyles = makeStyles(() => ({
	formSidePanel: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		height: '100%',
	},
	formBody: {
		display: 'contents',
	},
}))

const LookupsModule = () => {
	const { id: paramId } = useParams()

	const urlQueryParam = useUrlQueryParams()
	const actionQuery = urlQueryParam.get('action')
	const classes = useStyles()

	const { environment, lookupsModule } = useSelector((state) => state)
	const iconTheme = environment.theme.icons

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const dispatch = useDispatch()
	const isMounted = useRef(true)

	useEffect(() => {
		isMounted.current = true
		return () => (isMounted.current = false)
	}, [])

	useEffect(() => {
		var newFullScreenDataModString = localStorage.getItem('newFullScreenData_mod')
		if (!_.isEmpty(paramId) && newFullScreenDataModString != null) {
			var newFullScreenDataMod = JSON.parse(newFullScreenDataModString)
			var lookupsModuleTmp = newFullScreenDataMod.lookupsModule
			dispatch({
				type: LOOKUPS_ACTIONS.LOOKUPS_RESTORE_PRODUCER,
				payload: lookupsModuleTmp || {},
			})
			localStorage.removeItem('newFullScreenData_mod')
		} else {
			dispatch({
				type: LOOKUPS_ACTIONS.TAB_CHANGE,
				payload: LOOKUPS_ACTIONS.NAME,
			})

			if (_.isEmpty(lookupsModule?.lookupsProject)) {
				dispatch({
					type: LOOKUPS_ACTIONS.LOOKUPS_PROJECT,
					payload: environment?.lookups?.[0],
				})
			}
		}
	}, [environment?.lookups])

	useEffect(() => {
		if (!environment.refresh) return
		setLoading(true)
		dispatch({
			type: LOOKUPS_ACTIONS.LOOKUPS_PROJECT,
			payload: {},
		})
		dispatch({
			type: ENV_ACTIONS.CLEAR_LOOKUPS,
		})
		dispatch({
			type: ENV_ACTIONS.REFRESH,
			payload: false,
		})
	}, [environment.refresh])

	const showErrorMessage = () =>
		error && (
			<DoformsMessage message={error} severity={'error'} onMessageClosed={handleMessageClosed} />
		)

	const handleMessageClosed = () => {
		setError(null)
	}

	const { projectLoading } = useProject({ enabled: true })

	const sidePanel = () => (
		<div id="form-side-panel" className={classes.formSidePanel}>
			<EnvironmentProvider values={environment}>
				<LookupsDashboard
					lookupsProject={lookupsModule.lookupsProject}
					module={lookupsModule}
					loading={loading || projectLoading}
				/>
			</EnvironmentProvider>
		</div>
	)

	const formBody = () => (
		<div id="form-body" className={classes.formBody}>
			{showErrorMessage()}
			<LookupsData
				lookupsProject={lookupsModule.lookupsProject}
				environment={environment}
				module={lookupsModule}
				action={lookupsModule.action}
			/>
		</div>
	)

	return (
		<IconThemeProvider values={iconTheme}>
			<DashboardSplitPane sidePanel={sidePanel()} mainContent={formBody()} />
		</IconThemeProvider>
	)
}

export default LookupsModule
